<main @fade>
  <nb-card>
    <nb-card-body [nbSpinner]="loading">
      <div [ngClass]="{'active': productShow}" *ngIf="(data | async) as list">
        <div class="dam__center-title">
          <img src="/assets/images/new_logo.svg" alt="" height="20px">

          <h4>{{ h1 }}</h4>
          <small *ngIf="totalElements > 0">Всего {{ totalElements }} {{ createLabel(totalElements, 'файл|файла|файлов') }}</small>

          <app-dam-search-elastic [url]="getListURI()"/>

          <button nbButton nbTooltip="Скачать" (click)="downloadShare()" size="small">
            <nb-icon icon="download"/>
            Скачать
          </button>

          <app-view-changing-tabs (viewChangeEvent)="showProductBlocks($event)" [isShowList]="isShowList"/>
        </div>

        <app-plates-view [share]="true" [isShowProductList]="isShowList" [pagination]="pagination" [damElements]="list" [write]="false" (elementClickEventEmitter)="elementClickEventHandler($event)"/>
      </div>
    </nb-card-body>
  </nb-card>
</main>
